import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseViewProductsReceiving } from '../_models';

@Injectable({
  providedIn: 'root'
})
export class ViewReceivingProductsService {

 
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(
    customerId:string,
   token:string
  ): Observable<ResponseViewProductsReceiving[]> {
    const requestUrl = `${environment.apiUrl}/Receive/ViewReceivingProducts`;
    
    var Request = {};
    Request['receivingId'] = Number(customerId);

    return this._httpClient.post<ResponseViewProductsReceiving[]>(
      requestUrl,
      Request,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + token,
        }),
      }
    );
  }
}
